import { render } from "./IconNew.vue?vue&type=template&id=a3050f20&scoped=true"
import script from "./IconNew.vue?vue&type=script&lang=js"
export * from "./IconNew.vue?vue&type=script&lang=js"

import "./IconNew.vue?vue&type=style&index=0&id=a3050f20&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a3050f20"

export default script